'use strict'

import Form from "../utils/Form";

class TestDrive {
    constructor(){
		let wheelsActualRotation = 0;

		$('.menu.desktop.r .menu_testdrive').addClass('active');

        new Form().done((data) => {
			if(data.status==200){
				document.location=App.baseUrl + '/herramientas-de-compra/solicita-testdrive/completado/';
				return;
				var step = $('#next')[0].dataset.step;
				step = Number(step) + 1;
				$('#next').attr('data-step', step);
				$('.thanks h4 span').html($('#name').val());
				$('.thanks .description').html(data.description);
				$('.thanks img').attr('src', data.imagen);
				$('section.testDriveForm').fadeOut(function() {
					
					$('section.thanks').fadeIn();
				});
				$('.testDriveNav').fadeOut();
				$('#next').text('VOLVER AL HOME');
				$('#next').off('click').on('click', function(evt){
					evt.preventDefault();
					document.location=App.baseUrl;
				});
				$('.goBack').fadeOut();
			}
        });

        $('section.testDrive .header a').on('click', function(e) {
            e.preventDefault();
            var type = $(this).data('type');
            $('section.testDrive .header li').removeClass('active');
            $(this).closest('li').addClass('active');
            navTabActiveLineAnimated();
            $('section.testDrive .cars-container').animate({
                opacity: 0
            }, 700, function() {
				const wheels = $('.bx-wrapper').find('.car-image-wheel');
				wheels.css('transform', `rotate(0deg)`);
				testDrive.destroySlider();
				wheelsActualRotation = 0;

				$('section.testDrive .slider#' + type).find('.active').removeClass('active');
				if($('.testDrive').data('id_modelo')!=''){
					var pos=$('div[data-model='+$('.testDrive').data('id_modelo')+']').closest('.slide').index();
					var tab=$('div[data-model='+$('.testDrive').data('id_modelo')+']').closest('.slider').attr('id');
		
					options.startSlide=pos;
					$('div[data-model='+$('.testDrive').data('id_modelo')+']').closest('.slide').addClass('active_delay');
					$('.testDrive').data('id_modelo' ,'');
				}else{
					options.startSlide=0;
					$('section.testDrive .slider#' + type).find('.slide:first-child').addClass('active');
				}

                testDrive = $('section.testDrive .slider#' + type).bxSlider(options);
                $('section.testDrive .cars-container').animate({
                    opacity: 1
                }, 700);
//				setTimeout(function(){
//					$('section.testDrive .bx-wrapper .slider:first .slide.active').not('.bx-clone').find('.trims a:first').trigger('click');
//				}, 200);
            });
        });

        var options;

        var slideWidth;
        if ( $(window).width() > 768 && $(window).width() < 1023) {
            slideWidth = 950;
        } else if ($(window).width() > 1024) {
			slideWidth = 650;
		} else {
            slideWidth = 600;
        }

        if ($(window).width() > 768 && $(window).width() < 1023) {
            options = {
                slideWidth,
                minSlides: 1,
                maxSlides: 3,
                moveSlides: 1,
                pager: false,
                controls: false,
                slideMargin: 0,
				shrinkItems: false,
				responsive:false,
				speed: 1200,
                auto: false,		                
            };
        }else if ($(window).width() > 1024) {
			options = {
                slideWidth,
                minSlides: 1,
                maxSlides: 1,
                moveSlides: 1,
                pager: false,
                controls: false,
                slideMargin: 0,
				shrinkItems: true,
				responsive:true,
				speed: 1200,
                auto: false,		                
            };
		} else {
            options = {
                slideWidth,
                minSlides: 1,
                maxSlides: 3,
                moveSlides: 1,
                pager: false,
                controls: true,
                slideMargin: 0,
				shrinkItems: true,
                auto: false
            };
        }
		
		options.onSliderLoad=function(e, o, n) {
			$('#testdrive input[name=model]').val(this.getCurrentSlideElement().attr('data-model'));
			$('.slide .animated').removeClass('animated');
			//splitTextIntoWords();			
		};
		options.onSlideBefore=function(e, o, n) {
			var target;

			var old_model=$(this).find('.slide').not('.bx-clone').eq(o).data('model');

			target=$(this).find('.slide[data-model='+old_model+']');
			target.addClass('fadeOut');
			
			setTimeout(function() {
				target.removeClass('fadeOut');
			}, 2000);

			//console.log('e before', e);

			/*
			console.log('o', o);
			console.log('n', n);
			$(e).removeClass('fadeOut');
			if (o === 0 && n !== 1) {
				target = $(e).next();
				$(e).next().addClass('fadeOut');
			} else if (o === 6 && n !== 5) {
				target = $(e).prev();
				$(e).prev().addClass('fadeOut');
			} else if (o > n) {
				target = $(e).next();
				$(e).next().addClass('fadeOut');
			} else {
				target = $(e).prev();
				$(e).prev().addClass('fadeOut');
			};
			setTimeout(function() {
				$(target).removeClass('fadeOut');
			}, 4000);
			*/
		};
		options.onSlideAfter=function(e, o, n) {
			$(e).closest('.bx-wrapper').find('.slide').removeClass('active');
			$(e).addClass('active');
			$('#testdrive input[name=model]').val(this.getCurrentSlideElement().attr('data-model'));
			$(e).find('.animated').removeClass('animated');
		};

		options.onSlideNext=function(e, o, n) {			
			const wheels = $(e).closest('.bx-wrapper').find('.car-image-wheel');
			const rotationFactor = 120;
			wheelsActualRotation-=rotationFactor;
			wheels.css('transform', `rotate(${wheelsActualRotation}deg)`);
		};

		options.onSlidePrev=function(e, o, n) {
			const wheels = $(e).closest('.bx-wrapper').find('.car-image-wheel');
			const rotationFactor = 120;
			wheelsActualRotation+=rotationFactor;
			wheels.css('transform', `rotate(${wheelsActualRotation}deg)`);
		};
		
		if($('.testDrive').data('id_modelo')!=''){
			var pos=$('div[data-model='+$('.testDrive').data('id_modelo')+']').closest('.slide').index();
			var tab=$('div[data-model='+$('.testDrive').data('id_modelo')+']').closest('.slider').attr('id');

			options.startSlide=pos;
			$('.testDrive .header a[data-type='+tab+']').trigger('click');
		}else{
			options.startSlide=0;
			$('section.testDrive .slider#autos').find('.slide:first-child').addClass('active_delay');
		}

		$(document).on('siteLoaded', function(){
			$('.active_delay').removeClass('active_delay').addClass('active');
		});


        var testDrive = $('section.testDrive .slider#autos').bxSlider(options);

        $('section.testDrive .right').on('click', function(e) {
            e.preventDefault();
            testDrive.goToNextSlide();
        });
        $('section.testDrive .left').on('click', function(e) {
            e.preventDefault();
            testDrive.goToPrevSlide();
        });

		$('#next').on('click', function(e) {
			var step = $(this)[0].dataset.step;
			if (step !== '4') e.preventDefault();
			$('.goBack').fadeIn();
			switch(step) {
				case '1':
					$('section.testDrive').fadeOut(function() {
						$('section.dealership').fadeIn();
					});
					$('.testDriveNav li.active').removeClass('active').next().addClass('active');
					$('.testDriveNav .progressBar span').css('width', '66.6%');
					step = Number(step) + 1;
					break;
				case '2':
					$('section.dealership').fadeOut(function() {
						$('section.testDriveForm').fadeIn();
					});
					$('.testDriveNav li.active').removeClass('active').next().addClass('active');
					$('.testDriveNav .progressBar span').css('width', '100%');
					$(this).text('ENVIAR SOLICITUD');
					step = Number(step) + 1;
					break;
				case '3':
					$('#testdrive').submit();
					break;
			};
			$(this).attr('data-step', step);
			$('.goBack').attr('data-step', step);
		});

		$('.bottomOpts .goBack').on('click', function(e) {
			e.preventDefault();
			var step = $(this)[0].dataset.step;
			switch(step) {
				case '2':
					$('.goBack').fadeOut();
					$('section.dealership').fadeOut(function() {
						$('section.testDrive').fadeIn();
					});
					$('.testDriveNav li.active').removeClass('active').prev().addClass('active');
					$('.testDriveNav .progressBar span').css('width', '33.3%');
					break;
				case '3':
					$('section.testDriveForm').fadeOut(function() {
						$('section.dealership').fadeIn();
					});
					$('.testDriveNav li.active').removeClass('active').prev().addClass('active');
					$('.testDriveNav .progressBar span').css('width', '66.6%');
					$('#next').text('SIGUIENTE');
					break;
			};
			step = Number(step) - 1;
			$(this).attr('data-step', step);
			$('#next').attr('data-step', step);
		});


//        $('section.testDrive .trims a').on('click', function(e) {
//			$('#testdrive input[name=model]').val($(this).data('model'));
//			$('#testdrive input[name=version]').val($(this).data('id'));
//        });
//		$('section.testDrive .slider:first .slide.active').not('.bx-clone').find('.trims .active a').trigger('click');
		
			
        $('.dealership').find('input[type="radio"]').on('change', function (){
            $('#dealer').val($(this).val()).selectric('refresh');
        });

        $('section.testDrive .slide').on('click', function() {
            if (!$(this).hasClass('active')) {
                if ($(this).prev().hasClass('active')) {
                    setTimeout(function() {
                        testDrive.goToNextSlide();
                    }, 200);
                };
                if ($(this).next().hasClass('active')) {
                    setTimeout(function() {
                        testDrive.goToPrevSlide();
                    }, 200);
                };
            };
        });

        //if(window.navigator.userAgent.toLowerCase().indexOf("chrome") > 0) {
//            $("body").on("mousedown", ".trims a", function(e) { 
//                console.log(e);
//                setTimeout(function() {
//                    $(this).trigger('click');
//                }, 200)
//            });
//
//            $("body").on("mousedown", ".slide", function(e) { 
//                setTimeout(function() {
//                    $(this).trigger('click');
//                }, 200)
//            });
        //}


    }
}

export default TestDrive;